export default "__VITE_ASSET__BJmy5Fns__"